import { create } from "zustand";
import { persist } from "zustand/middleware";

import { ModulesStore } from "./types";

const useModulesStore = create<ModulesStore>()(
  persist(
    (set) => ({
      allItemsQty: 0,
      setAllItemsQty: (allItemsQty) => set({ allItemsQty }),
    }),
    {
      name: "modules-new-list-store",
    }
  )
);

export default useModulesStore;
